/** ----------------------------------------
    Generator helper
 ---------------------------------------- */

export default class RouterHelper {
    
    /**
     * @param  {[object]} context
     * @param  {any} middleware
     * @param  {number} index
     */
    static nextFactory(context: [object], middleware: any, index: number) {
        const subsequentMiddleware = middleware[index];
    
        if (!subsequentMiddleware) return context.next;
    
        return (...parameters) => {
            context.next(...parameters);
            const nextMiddleware = this.nextFactory(context, middleware, index + 1);
            subsequentMiddleware({ ...context, next: nextMiddleware });
        };
    }
    
    /**
     * @param  {[object]} router
     * @param  {[object]} to
     * @param  {[object]} from
     * @param  {any} next
     */
    static handleMiddleware(router: [object], to: [object], from: [object], next: any) {
        to.matched.some(record => {
            if (!record.meta.middleware) return next();
    
            const middleware = Array.isArray(record.meta.middleware)
                ? record.meta.middleware
                : [record.meta.middleware];
    
            const context = {
                from,
                next,
                router,
                to: record,
            };
            const nextMiddleware = this.nextFactory(context, middleware, 1);
    
            return middleware[0]({ ...context, next: nextMiddleware });
        });
    }
}